import { resetMainSelection } from '@/atoms'
import { useCallback } from 'react'

export function useActions() {
  const onReset = useCallback(() => {
    resetMainSelection('orderSteps')
  }, [])

  return {
    onReset,
  }
}
